import type { FC } from 'react';
import { CageConsumptionMetricApiId, ConsumptionMetric, ConsumptionMetricDelete } from '@/model/Consumption.model.ts';
import { useDispatch } from 'react-redux';
import { modalAction } from '@/utils/modal.tsx';
import ActionList from '@/components/UI/SelectDropDown/Menus/ActionList.tsx';
import SelectDropDown from '@/components/UI/SelectDropDown';
import { EditConsumptionRequest } from '@/components/Workflow/Show/WorkflowConsumption.tsx';
import { intakeLabels } from './Consumption.utils.ts';

export type DeleteConsumptionRequest = {
  variables: ConsumptionMetricDelete;
};

interface ActionsProps {
  onExcludeClick: () => void;
  onEditClick: (consumptionMetricApiId: CageConsumptionMetricApiId, request: EditConsumptionRequest) => void;
  onDeleteClick: (consumptionMetricApiId: CageConsumptionMetricApiId, request: DeleteConsumptionRequest) => void;
  currentMetric: ConsumptionMetric;
  previousMetric: ConsumptionMetric | undefined;
  canEdit: boolean;
  canExclude: boolean;
}

const ConsumptionActions: FC<ActionsProps> = ({
  onExcludeClick,
  onEditClick,
  onDeleteClick,
  currentMetric,
  previousMetric,
  canEdit,
  canExclude,
}) => {
  const { openModal } = modalAction(useDispatch());

  return (
    <SelectDropDown
      title="Actions"
      className="f6 basier-reg pl0 stateless blue"
      alignMenu="left"
      testId="cage-metric-actions"
    >
      <ActionList
        actions={[
          {
            name: 'Edit',
            action: () =>
              openModal('EDIT_CAGE_METRIC', {
                handleSave: onEditClick,
                currentMetric,
                previousMetric,
                canEdit,
              }),
          },
          ...(canExclude
            ? [
                {
                  name: 'Exclude',
                  action: onExcludeClick,
                },
              ]
            : []),
          ...(canEdit
            ? [
                {
                  name: 'Delete',
                  className: 'red',
                  action: () =>
                    openModal('CONFIRM_DELETE_CONSUMPTION', {
                      title: `Are you sure you would like to delete this ${intakeLabels[currentMetric.type].label.toLowerCase()} measurement?`,
                      text: `Deleting will permanently remove this cage measurement and all related animal measurements. This action cannot be undone.`,
                      btnTxt: 'Delete',
                      onClick: (reason?: string) =>
                        onDeleteClick(currentMetric.api_id, { variables: { reason_for_change: reason ?? null } }),
                    }),
                },
              ]
            : []),
        ]}
      />
    </SelectDropDown>
  );
};
export default ConsumptionActions;
